import React from "react";
import Select from "react-select";

const errorSelectStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
        "&:hover": {
            borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
        },
    }),
};

const CostAllocation = ({ rows = [], onChange, onTickChange, handleTVOCAndFormaldehydeChange, errors = {}, isDisabled }) => {
    return (
        <>
            <div className="cost-allocation-list member-list">
                <div className="content-section">
                    <div className="table-section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Cert Number</th>
                                    <th>Item Code</th>
                                    <th>Tick Rating</th>
                                    <th>TVOC Emission</th>
                                    <th>Formaldehyde Emission</th>
                                </tr>
                            </thead>

                            <tbody>
                                {rows.map((row) => {
                                    const rowErrors = errors[row.id] || {};
                                    const hasItemCodeError = Boolean(rowErrors.itemCode);
                                    const hasTickError = Boolean(rowErrors.tickRating);
                                    const hasTvocEmissionError = Boolean(rowErrors.tvocEmission);
                                    const hasFormalEmissionError = Boolean(rowErrors.formaldehydeEmission);

                                    return (
                                        <tr key={row.id}>
                                            <td>{row.label} <span className="text-danger">*</span></td>

                                            <td>
                                                <div className="form-group">
                                                    <Select
                                                        className="custom-checkbox-select"
                                                        value={row.value}
                                                        options={row.options}
                                                        onChange={(selected) => onChange?.(row.id, selected)}
                                                        isMulti={row.isMultiSelect ?? false}
                                                        placeholder={row.placeholder ?? "Select"}
                                                        styles={errorSelectStyles}
                                                        hasError={hasItemCodeError}
                                                        isDisabled={isDisabled}
                                                    />
                                                    {hasItemCodeError && (
                                                        <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                            {rowErrors.itemCode}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>

                                            <td>
                                                <div className="form-group">
                                                    <Select
                                                        className="custom-checkbox-select"
                                                        value={row.tickValue}
                                                        options={row.tickOptions}
                                                        onChange={(selected) => onTickChange?.(row.id, selected)}
                                                        placeholder="Select"
                                                        styles={errorSelectStyles}
                                                        hasError={hasTickError}
                                                        isDisabled={isDisabled}
                                                    />
                                                    {hasTickError && (
                                                        <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                            {rowErrors.tickRating}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control${hasTvocEmissionError ? " is-invalid" : ""}`}
                                                        value={row.tvocEmission ?? ""}
                                                        onChange={(e) => handleTVOCAndFormaldehydeChange?.(row.id,"tvocEmission", e.target.value)}
                                                        onBlur={(e) => handleTVOCAndFormaldehydeChange?.(row.id, "tvocEmission",  e.target.value.trim())}
                                                        disabled={isDisabled}
                                                    />
                                                    {hasTvocEmissionError && (
                                                        <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                            {rowErrors.tvocEmission}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className={`form-control${hasFormalEmissionError ? " is-invalid" : ""}`}
                                                        value={row.formaldehydeEmission ?? ""}
                                                        onChange={(e) => handleTVOCAndFormaldehydeChange?.(row.id, "formaldehydeEmission", e.target.value)}
                                                        onBlur={(e) => handleTVOCAndFormaldehydeChange?.(row.id, "formaldehydeEmission", e.target.value.trim())}
                                                        disabled={isDisabled}
                                                    />
                                                    {hasFormalEmissionError && (
                                                        <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                            {rowErrors.formaldehydeEmission}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>

                                        </tr>
                                    );
                                })}

                                {rows.length === 0 && (
                                    <tr>
                                        <td colSpan={4}>No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CostAllocation